import { Alert, MenuItem, TextField, Typography } from '@mui/material';

import type { IntegrationCatalogEntry } from '@/api/integrations';

import type { IntegrationKind } from './types';

interface Props {
  kind: IntegrationKind;
  restech: string | null;
  onRestech: (r: string) => void;
  catalog: IntegrationCatalogEntry[];
  loading: boolean;
}

export function Step2System({ kind, restech, onRestech, catalog, loading }: Props) {
  if (kind === 'fleet') {
    return (
      <Alert severity="info">
        Quartix is the only supported vehicle-tracking system. Continue to configure it.
      </Alert>
    );
  }

  const manageable = catalog.filter((e) => e.manageable);
  return (
    <>
      <Typography variant="subtitle2" gutterBottom>
        Booking system
      </Typography>
      <TextField
        select
        fullWidth
        label="System"
        value={restech ?? ''}
        disabled={loading}
        onChange={(e) => onRestech(e.target.value)}
      >
        {manageable.map((e) => (
          <MenuItem key={e.id} value={e.id}>
            {e.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
